import axios from 'axios';
import config from '../config';

export const videoAxiosInstance = axios.create({
  baseURL: config('production').serverUrl,
  withCredentials: true,
});

export const s3AxiosInstance = axios.create({});

export const updateVideoAxiosAuth = (auth: string) => {
  videoAxiosInstance.defaults.headers.common.Authorization = auth;
};

export const updateVideoAxiosBaseURL = (url: string) => {
  videoAxiosInstance.defaults.baseURL = url;
};
